import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { i18n } from "./i18n";
import { createPinia } from "pinia";
import VueDatePicker from "@vuepic/vue-datepicker";
import VueKonva from "vue-konva";
import { useLangStore } from "@/stores/langStore";

import "./assets/tailwind.css";
import "./assets/fonts.css";
import "./assets/app.css";
import "leaflet/dist/leaflet.css";
import "@vuepic/vue-datepicker/dist/main.css";

const app = createApp(App);

app.use(router);
app.use(i18n);
app.use(VueKonva);
app.use(createPinia());

const langStore = useLangStore();
langStore.initLang();

app.component("VueDatePicker", VueDatePicker);

app.mount("#app");
